// The pre-token antd theme, kept as the default until the generated design tokens are verified.
import { theme as AntdTheme, type ThemeConfig } from 'antd';
import type { Env0Theme } from '@env0/ui-theme/env0';

const { darkAlgorithm, defaultAlgorithm } = AntdTheme;

export const getLegacyAntdTheme = (theme: Env0Theme): ThemeConfig => {
  const isDarkTheme = theme.mode === 'dark';

  return {
    algorithm: isDarkTheme ? darkAlgorithm : defaultAlgorithm,
    token: {
      borderRadius: 4,
      colorBgContainerDisabled: theme.primaryGray,
      colorBgMask: theme.modalMaskGray,
      colorInfoBg: theme.lightBlue,
      colorPrimary: theme.limeYellow,
      colorText: theme.primaryBlack,
      colorLink: theme.primaryBlack,
      colorLinkHover: theme.primaryBlack,
      colorLinkActive: theme.primaryBlack,
      fontFamily: "'ProximaNova', sans-serif",
      fontSize: 14,
      colorTextLightSolid: theme.primaryBlack,
      colorPrimaryHover: theme.limeYellow
    },
    components: {
      Button: {
        lineHeight: 1 // 100% of font size
      },
      Card: {
        boxShadowTertiary: 'none'
      },
      Collapse: {
        colorBgContainer: theme.primaryWhite,
        colorFillAlter: theme.primaryWhite,
        paddingSM: 24,
        padding: 24,
        colorTextHeading: theme.primaryBlack
      },
      Dropdown: {
        fontSize: 12
      },
      Menu: {
        itemSelectedBg: theme.limeYellow,
        itemMarginInline: 0,
        itemBorderRadius: 0,
        colorTextDisabled: theme.textGray
      },
      Table: {
        colorFillAlter: theme.primaryWhite,
        colorTextHeading: theme.primaryBlack,
        fontWeightStrong: 500,
        colorBgContainer: theme.primaryWhite
      },
      Tabs: {
        cardBg: theme.backgroundGray,
        colorBorder: 'transparent'
      },
      Tooltip: {
        colorBgDefault: theme.tooltipBackground,
        colorTextLightSolid: theme.tooltipText
      },
      Drawer: {
        colorBgElevated: theme.drawerBackground
      },
      DatePicker: {
        colorPrimary: theme.oliveGreen
      },
      Input: {
        controlHeight: 25,
        colorPrimaryHover: theme.oliveGreen
      },
      InputNumber: {
        controlHeight: 25,
        colorPrimaryHover: theme.oliveGreen
      },
      Select: {
        colorPrimaryHover: theme.oliveGreen,
        colorTextPlaceholder: theme.textGray,
        controlHeight: 25,
        controlHeightSM: 25,
        fontSize: 12
      },
      Radio: {
        colorPrimary: theme.oliveGreen,
        colorPrimaryHover: theme.oliveGreen,
        colorPrimaryActive: theme.oliveGreen
      },
      Checkbox: {
        colorPrimary: theme.limeYellowActive,
        colorPrimaryHover: theme.limeYellowActive
      },
      Pagination: {
        colorPrimary: theme.limeYellowActive,
        colorPrimaryHover: theme.limeYellowActive
      },
      Steps: {
        colorPrimary: theme.limeYellowActive,
        colorPrimaryHover: theme.limeYellowActive
      },
      Switch: {
        colorPrimary: theme.limeYellowActive,
        colorPrimaryHover: theme.limeYellowActive
      },
      Spin: {
        colorPrimary: theme.limeYellowActive
      },
      Statistic: {
        titleFontSize: 16
      }
    }
  };
};
